<template>
  <hr class="hr" />
  <h1>Kérjen Árajánlatot!</h1>
  <div class="d-flex flex-column justify-content-around align-items-center m-2">
    <p>Előzetes árajánlat kéréshez kérjük adja meg az árnyékoló típusát, színét illetve a darabszámot.
      <br>Kérjük amennyiben tudja, adja meg a méreteket is (pl.: ajtó, ablak vagy akár erkély szélessége, magassága)
      <br>Ha tud kérjük mellékeljen képeket is.</p>
  </div>
  <ContactUs />
</template>

<script>
import ContactUs from './ContactUs.vue';

export default {
    name: 'ContactUsSection',
    components: {
        ContactUs
    }
}
</script>

<style lang="scss" scoped>

</style>